var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Grid } from '@mui/material';
import * as React from 'react';
import { styled } from '../../styled';
var panelComponentName = 'QuantumPanel';
export var Root = styled(Grid, {
    name: panelComponentName,
    slot: 'Root',
})(function (_a) {
    var theme = _a.theme, position = _a.position;
    var borderDivider = "1px solid ".concat(theme.tokens.color_border_default);
    var positionBorder = position === 'start' ? { borderRight: borderDivider } : position === 'end' ? { borderLeft: borderDivider } : {};
    return __assign({ backgroundColor: theme.tokens.color_bg_layer, overflow: 'hidden', display: 'flex', flexDirection: 'column' }, positionBorder);
});
export var Panel = React.forwardRef(function (props, ref) {
    var position = props.position, children = props.children, rootProps = __rest(props, ["position", "children"]);
    return (React.createElement(Root, __assign({ ref: ref, position: position }, rootProps), children));
});
